import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSupport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSupport"><Path d="M6.05338 9C6.45034 6.22748 9.01672 4 12.25 4C15.4833 4 18.0497 6.22748 18.4466 9H17.5V17.5H18.6051C18.1748 18.9457 16.8355 20 15.25 20H13V18H11V22H15.25C17.9784 22 20.2428 20.0133 20.6755 17.4077C21.728 17.113 22.5 16.1467 22.5 15V11.5C22.5 10.2787 21.6243 9.26198 20.4665 9.04345C20.0849 5.04041 16.4916 2 12.25 2C8.00841 2 4.41506 5.04041 4.03348 9.04345C2.87572 9.26198 2 10.2787 2 11.5V15C2 16.3807 3.11929 17.5 4.5 17.5H7V9H6.05338Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSupport;
